import React, { FC, useCallback, useState } from 'react'
import { flatten } from '@utils/string-helper'
import './switch.css'


interface Props extends Omit<React.HTMLAttributes<HTMLLabelElement>, 'onChange'> {
    checked?: boolean
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
    disabled?: boolean
    invalid?: boolean
    beta?: boolean
}

const Switch: FC<Props> = (props) => {
    const { className: classProps, checked, onChange, disabled, invalid = false, beta = false, ...labelProps } = props
    const className = flatten(disabled ? 'disabled' : undefined, invalid ? 'invalid' : undefined, beta ? 'beta' : undefined, 'switch', classProps)

    return (
        <label className={className} {...labelProps}>
            <input type="checkbox" checked={checked} onChange={onChange} disabled={disabled} />
            <span className="slider" />
        </label>
    )
}

const defaultOnChange = (v: boolean) => v
export const useSwitch = (config?: {
    initValue?: boolean,
    onChange?: (isChecked: boolean) => boolean
}): [boolean, { onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void, checked: boolean }, (value: boolean) => void] => {
    const { initValue = false, onChange: onChangeProp = defaultOnChange } = config ?? {}
    const [checked, setChecked] = useState(initValue)

    const onChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        var value = e?.currentTarget?.checked ?? false
        injectValue(value)
    }, [setChecked])

    function injectValue(value: boolean) {
        setChecked(onChangeProp(value))
    }

    return [checked, { onChange, checked }, injectValue]
}

export default Switch